<template>
        <textarea cols="80" id="ckeditors" name="ckeditors"> 

		</textarea>
</template>
<script>
export default {
    name: 'ckeditor',
    props: {
        ckeditorHeight:{
            type: String,
            required: true
        },
        editorText:{
            type: String,
            required: true
        }
    },
    data () {
        return {
            editor:'',
        }
    },
    created:function () {
        
	},
    methods:{

    },
    mounted() {
        var editor = CKEDITOR.replace('ckeditors', {
            removePlugins:'elementspath,resize',
            codeSnippet_theme: 'zenburn',
            height:this.ckeditorHeight
        });
        this.editor = editor;
        editor.setData(this.editorText);
        CKEDITOR.instances['ckeditors'].on("blur", function () {
            let data = CKEDITOR.instances['ckeditors'].getData();
            this.$emit('func',data)
        }.bind(this));
    },
    beforeDestory() {
    },
    destroyed: function () {
        this.editor.destroy(true);
    },
    watch:{
        editorText: {
            //immediate: true,  // 这是为了第一次拿到值的时候就对sd进行监听
            handler(val, oldval){
                this.editor.setData(val);
            }
        }
    }
}
</script>
<style scoped = "scoped"  lang = "less">

</style>



// WEBPACK FOOTER //
// src/components/common/ckeditor.vue